// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import VueFusionCharts from 'vue-fusioncharts'
import FusionCharts from 'fusioncharts'
import Charts from 'fusioncharts/fusioncharts.charts'
import vSelect from 'vue-select';
import VueCookies from 'vue-cookies'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
import VueEvents from 'vue-event-handler';
import ImageUploader from 'vue-image-upload-resize'


Vue.use(ImageUploader)

Vue.use(VueEvents)
// cssVars()
Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(VueCookies)
Vue.use(VueFusionCharts, FusionCharts, Charts)
Vue.component('v-select', vSelect);

const datepickerOptions={
  colors: {
    selected: '#00BFFF',
    inRange: '#87CEEB',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#87CEEB',
    disabled: '#fff',
    hoveredInRange: '#87CEEB'
  },
}
Vue.use(AirbnbStyleDatepicker,datepickerOptions)
Vue.config.errorHandler = function(err, vm, info) {
  console.log(`Error: ${err.toString()}\nInfo: ${info}`);
}


VueCookies.config('7d')
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  data: {
    window: {
      width: 0,
      height: 0
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if(this.window.width<822 && this.window.height<674){
        alert("Please turn the screen.")
      }
    }
  }
})



